module.exports = __webpack_public_path__ + "static/media/lang-es-419.94469bbc.svg";